import Backdrop from '@mui/material/Backdrop';
import React, { useState } from 'react';

import { CookieConsentDialog } from '@/components/layout/AppCookieConsent/CookieConsentDialog';
import { useCookieConsent } from '@/hooks/useCookieConsent';

export const CookieConsentModal: React.FC = () => {
  const { valid } = useCookieConsent();
  const [show, setShow] = useState(!valid);

  return (
    <Backdrop open={show}>
      <CookieConsentDialog
        show={show}
        setShow={setShow}
        defaultGaChecked={true}
        showAcceptButton={true}
        acceptId="SH.BTN.ACCEPTCOOKIES"
      />
    </Backdrop>
  );
};
